import type { DiscoverItem, DiscoverSegment } from "../../types";

export interface CategoryStyle {
  /** Category colour — used for ring, badge, dot, card chip, filter chip. */
  readonly color: string;
  /** SVG path `d` drawn in a 14×14 viewBox, stroke = currentColor. */
  readonly glyph: string;
}

const PIN = "M7 2a4 4 0 014 4c0 3-4 6-4 6S3 9 3 6a4 4 0 014-4M7 5a1 1 0 100 2 1 1 0 000-2";
const FORK = "M5 2v4M5 6c-1 0-1.5-.5-1.5-1.5V2M5 6v6M9.5 2c-.8 0-1.5.7-1.5 1.5V6c0 .8.7 1.5 1.5 1.5V12";
const BED = "M2 9h10M2 9V5h4v2h6v2M12 9V7";
const FLOWER = "M7 4v2M7 8v2M5 7h2M9 7h-2M5 5l1 1M9 9l-1-1M5 9l1-1M9 5l-1 1";
const PERSON = "M7 4a2 2 0 100 4 2 2 0 000-4M3 12c0-2 2-3 4-3s4 1 4 3";
const TICKET = "M2 5h10v4H2zM6 5v4";
// Flagstick planted on a green: pole from the ground up, pennant to the right.
const GOLF_FLAG = "M3 11h8M6 11V3M6 3l4.5 1.6L6 6.2";
// Martini glass: rim, converging sides, stem, foot.
const GLASS = "M3 3h8L7 8v3M5 11h4";
// Beach parasol: canopy arc over a pole planted in the sand.
const PARASOL = "M2 7a5 5 0 0110 0M7 7v5";

export const CATEGORY_STYLE: Record<DiscoverSegment, CategoryStyle> = {
  locations: { color: "#E5B265", glyph: PIN },
  restaurants: { color: "#E5733A", glyph: FORK },
  stays: { color: "#6B57C9", glyph: BED },
  spas: { color: "#D9568C", glyph: FLOWER },
  guides: { color: "#2BA39A", glyph: PERSON },
  golf: { color: "#4C8F3F", glyph: GOLF_FLAG },
  nightlife: { color: "#B23FBF", glyph: GLASS },
  "beach-clubs": { color: "#1FA8C7", glyph: PARASOL },
  activities: { color: "#040033", glyph: TICKET },
  bookable: { color: "#040033", glyph: TICKET },
};

export function styleForItem(item: Pick<DiscoverItem, "segment" | "mode">): CategoryStyle {
  return (
    CATEGORY_STYLE[item.segment] ??
    (item.mode === "explore" ? CATEGORY_STYLE.locations : CATEGORY_STYLE.bookable)
  );
}
